<div *ngIf="settingData && checkIDState === 1">
  <div id="overview-background" style="background-image: url({{settingData.img1}});">
    <nav>
      <img class="logo" src="../../assets/images/logo1.png">
      <div class="menu" *ngIf="owner">
        <span></span>
        <ul>
          <li><a (click)="routerService.GoToSetting(id)">設定</a></li>
          <li><a (click)="routerService.GoToControl(id)">控制</a></li>
          <li><a (click)="routerService.GoToOverview(id)">播放清單</a></li>
        </ul>
      </div>
    </nav>
    <!-- <img src="{{ settingData.img1 }}" id="background" /> -->
    <div id="control-background">
      <div id="control-screen" *ngIf="checkIDState === 1">
        <div id="content" (scroll)="onScroll($event)">
          <H6 id="title">播放清單</H6>
          <span id="email">
            <mat-icon id="emailicon">email</mat-icon>
            <span>: support@hibiki-rain.com</span>
          </span>
          <!-- <mat-paginator
                        [length]="paginatorLength"
                        [pageSize]="paginatorPageSize"> -->
          <mat-table
            #table
            [dataSource]="donateList.slice().reverse()"
            id="donatelist"
            class="mat-elevation-z8"
          >
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> 贊助人 </mat-header-cell>
              <mat-cell #index *matCellDef="let element; index as i">
                {{ element.name }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="donate">
              <mat-header-cell *matHeaderCellDef> 金額 </mat-header-cell>
              <mat-cell *matCellDef="let element; index as i">
                {{ element.donate }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="time">
              <mat-header-cell *matHeaderCellDef> 影片 </mat-header-cell>
              <mat-cell *matCellDef="let element; index as i">
                <a href="{{ element.yt }}" target="_blank">{{ element.yt }}</a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="msg">
              <mat-header-cell *matHeaderCellDef> 訊息 </mat-header-cell>
              <mat-cell *matCellDef="let element; index as i">
                {{ element.msg }}
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      </div>
    </div>
  </div>
</div>
